import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=10b8502d&scoped=true&"
import script from "./MainDialog.vue?vue&type=script&lang=js&"
export * from "./MainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8502d",
  null
  
)

export default component.exports